import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';
import { GridHeaderFilterDropdownTemplateDirective } from './alphabetfilter.dropdown.template.directive';

@Directive({ selector: 'grid-header-filter-dropdown' })
export class GridHeaderFilterDropdownDirective {
  // @Input()
  @ContentChild(GridHeaderFilterDropdownTemplateDirective, { read: TemplateRef })
  template: TemplateRef<any>;
}
